module.exports = __webpack_public_path__ + "static/img/training1.77a221ae.png";